import React from 'react';
import PropTypes from 'prop-types';
import Chessboard from './index';
import ChessboardItem from './item';

const ChessboardRenderer = ({ items, onOpenContact, deeplinkId }) => {
  return (
    <Chessboard deeplinkId={deeplinkId}>
      {items.map((item, i) => (
        <ChessboardItem key={i} {...item} onOpenContact={onOpenContact} />
      ))}
    </Chessboard>
  );
};

ChessboardRenderer.propTypes = {
  items: PropTypes.arrayOf(PropTypes.object),
  onOpenContact: PropTypes.func,
  deeplinkId: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default ChessboardRenderer;
